export default (invoices: any[]) => {
  return invoices.sort((a, b) => b.nextDueDate.seconds - a.nextDueDate.seconds);
}
